import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/categories?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/categories/${id}`, { params });
}

export async function create(body) {
  return request(`/product/categories`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/categories/${id}`, {
    method: 'POST',
    body,
  });
}
